import React from 'react';
import PropTypes from 'prop-types';
import PhotoGallery from './PhotoGallery';
import { getClassificationByImageType } from '../Segments/SegmentPhotos/constants';

/**
 * SegmentPhotos Component
 *
 * @param litterDataForSegment array from littersBySegmentId for the specified segmentId
 */
export default function SegmentPhotos({ litterDataForSegment }) {
    const formatLittersForGallery = () => {
        if (litterDataForSegment && litterDataForSegment.length > 0) {
            const formattedLitters = litterDataForSegment.map(
                (litter, photoIndex) => {
                    return {
                        photoIndex, //used to select image in <ImageGallery/> component
                        photoUrl: litter.file,
                        classification: litter.classification
                            ? litter.classification
                            : getClassificationByImageType(litter.imageType), // Litterati-Research new flow: doesn't have a classification, so we determine it by the imageType
                        imageId: litter.imageId, // If not a litter, this will be undefined.  This enables deleting a specific litter photo by imageId.
                    };
                },
            );
            return formattedLitters ? formattedLitters.flat() : [];
        } else return [];
    };

    const formatLittersForBreakdown = () => {
        if (litterDataForSegment && litterDataForSegment.length > 0) {
            return litterDataForSegment.reduce(
                (acc, curr) => {
                    const classification = curr.classification
                        ? curr.classification
                        : getClassificationByImageType(curr.imageType);
                    if (
                        classification !== 'BAGGAGE' &&
                        classification !== 'COLLECTED'
                    ) {
                        switch (classification) {
                            case 'SEGMENT_INTRO':
                                acc.segmentIntros += 1;
                                break;

                            case 'BIN':
                                acc.bins += 1;
                                break;

                            case 'LITTER':
                                acc.litters += 1;
                                break;

                            case 'HOTSPOT':
                                acc.hotspots += 1;
                                break;

                            default:
                                acc.litters += 1;
                                break;
                        }
                    }
                    return acc;
                },
                { segmentIntros: 0, bins: 0, litters: 0, hotspots: 0 },
            );
        } else return { segmentIntros: 0, bins: 0, litters: 0, hotspots: 0 };
    };

    return litterDataForSegment ? (
        <PhotoGallery
            photos={formatLittersForGallery()}
            photoBreakdown={formatLittersForBreakdown()}
        />
    ) : (
        <p className="p-4">No Gallery Available</p>
    );
}

SegmentPhotos.propTypes = {
    litterDataForSegment: PropTypes.array,
};
